import(/* webpackMode: "eager" */ "/vercel/path0/web/web/src/app/(authenticated)/dashboard/teams/page.tsx");
